module.exports = __webpack_public_path__ + "img/share_pause.ac9b9479.svg";